// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useI18n } from '../context/I18nContext';

export default function Reports() {
    const { t } = useI18n();
    const [tab, setTab] = useState('sales');
    const [sales, setSales] = useState(null);
    const [collection, setCollection] = useState(null);
    const [inventory, setInventory] = useState(null);
    const [crm, setCrm] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        Promise.all([
            api.get('/reports/sales'),
            api.get('/reports/collection'),
            api.get('/reports/inventory'),
            api.get('/reports/crm'),
        ]).then(([s, c, i, cr]) => {
            setSales(s.data.data);
            setCollection(c.data.data);
            setInventory(i.data.data);
            setCrm(cr.data.data);
        }).finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <div className="text-center py-5"><div className="spinner-border text-success" /></div>;
    }

    return (
        <div>
            <h4 className="mb-1">Reports</h4>
            <p className="text-muted mb-4">Sales, collection, inventory & CRM analytics</p>

            <ul className="nav nav-tabs mb-3">
                {['sales', 'collection', 'inventory', 'crm'].map((x) => (
                    <li className="nav-item" key={x}>
                        <button className={`nav-link text-capitalize ${tab === x ? 'active' : ''}`} onClick={() => setTab(x)}>{x}</button>
                    </li>
                ))}
            </ul>

            {tab === 'sales' && sales && (
                <>
                    <div className="row g-3 mb-3">
                        <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                            <div className="text-muted small">Total Bookings</div>
                            <div className="fs-4 fw-bold">{sales.summary.count}</div>
                        </div></div></div>
                        <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                            <div className="text-muted small">Sale Value</div>
                            <div className="fs-5 fw-bold">৳ {sales.summary.totalValue?.toLocaleString()}</div>
                        </div></div></div>
                        <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                            <div className="text-muted small">Commission</div>
                            <div className="fs-5 fw-bold">৳ {sales.summary.totalCommission?.toLocaleString()}</div>
                        </div></div></div>
                    </div>
                    <div className="card table-card mb-3">
                        <div className="card-header fw-semibold">By Unit Type (Flat / Land Share / etc.)</div>
                        <div className="card-body">
                            <div className="row g-2">
                                {Object.entries(sales.summary.byType || {}).map(([type, v]) => (
                                    <div className="col-md-3" key={type}>
                                        <div className="border rounded p-2">
                                            <div className="text-capitalize fw-semibold">{type.replace('_', ' ')}</div>
                                            <div className="small text-muted">{v.count} units · ৳ {v.value.toLocaleString()}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="card table-card">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Booking</th>
                                        <th>Customer</th>
                                        <th>Project / Unit</th>
                                        <th>Type</th>
                                        <th>Price</th>
                                        <th>Sales Exec</th>
                                        <th>Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {sales.bookings.map((b) => (
                                        <tr key={b.id}>
                                            <td>{b.booking_no}</td>
                                            <td>{b.customer?.name}</td>
                                            <td>{b.project?.name} · {b.unit?.unit_number}</td>
                                            <td className="text-capitalize">{(b.unit_type_snapshot || b.unit?.unit_type || '').replace('_', ' ')}</td>
                                            <td>৳ {Number(b.final_price).toLocaleString()}</td>
                                            <td>{b.salesExecutive?.name || '—'}</td>
                                            <td>{b.booking_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

            {tab === 'collection' && collection && (
                <>
                    <div className="card stat-card mb-3" style={{ maxWidth: 320 }}>
                        <div className="card-body">
                            <div className="text-muted small">Total Collected</div>
                            <div className="fs-4 fw-bold text-success">৳ {collection.total?.toLocaleString()}</div>
                            <div className="small text-muted">{collection.count} payments</div>
                        </div>
                    </div>
                    <div className="card table-card">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead className="table-light">
                                    <tr><th>Receipt</th><th>Customer</th><th>Booking</th><th>Amount</th><th>Date</th></tr>
                                </thead>
                                <tbody>
                                    {collection.payments.map((p) => (
                                        <tr key={p.id}>
                                            <td>{p.receipt_no}</td>
                                            <td>{p.customer?.name}</td>
                                            <td>{p.booking?.booking_no}</td>
                                            <td>৳ {Number(p.amount).toLocaleString()}</td>
                                            <td>{p.payment_date}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </>
            )}

            {tab === 'inventory' && inventory && (
                <div className="row g-3">
                    {inventory.map((row) => (
                        <div className="col-md-6" key={row.project.id}>
                            <div className="card table-card h-100">
                                <div className="card-header fw-semibold">{row.project.name} ({row.project.code})</div>
                                <div className="card-body">
                                    <div className="d-flex gap-3 mb-2 small">
                                        <span>Total: <strong>{row.total}</strong></span>
                                        <span className="text-success">Available: {row.available}</span>
                                        <span className="text-warning">Booked: {row.booked}</span>
                                        <span className="text-primary">Sold: {row.sold}</span>
                                    </div>
                                    {Object.entries(row.byType || {}).map(([type, v]) => (
                                        <div key={type} className="small border-top pt-1 mt-1">
                                            <span className="text-capitalize fw-semibold">{type.replace('_', ' ')}</span>
                                            : {v.total} total · {v.available} available · {v.booked} booked · {v.sold} sold
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {tab === 'crm' && crm && (
                <div className="row g-3">
                    <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Total Leads</div>
                        <div className="fs-4 fw-bold">{crm.total}</div>
                    </div></div></div>
                    <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Converted</div>
                        <div className="fs-4 fw-bold text-success">{crm.converted}</div>
                    </div></div></div>
                    <div className="col-md-4"><div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Conversion Rate</div>
                        <div className="fs-4 fw-bold">{crm.conversionRate}%</div>
                    </div></div></div>
                    <div className="col-12">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">By Status</div>
                            <div className="card-body d-flex flex-wrap gap-2">
                                {Object.entries(crm.byStatus || {}).map(([st, n]) => (
                                    <span key={st} className="badge bg-secondary badge-status text-capitalize">{st.replace('_', ' ')}: {n}</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
